import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_fhasta, p_nomina, p_producto) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fhasta": p_fhasta,
					"p_nomina": p_nomina,
					"p_producto": p_producto
				  })
			})
	},

	marcarparapago(p_email, p_usuario, p_fecha, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.marcarparapago",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha,
					"p_siniestro": p_siniestro
				  })
			})
	},

	desmarcarparapago(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.desmarcarparapago",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	modificarfecha(p_email, p_usuario, p_fecha, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.modificarfecha",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha,
					"p_siniestro": p_siniestro
				  })
			})
	},

	quitarfecha(p_email, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.fnc_quitarfecha",
				"p_args_in": JSON.stringify({
					"p_siniestro": p_siniestro
				  })
			})
	},

    DocContishare(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_nomina.recuperar_doccontishare",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

}